// config
// utils
import api from 'api';
import ticketService from '../ticket-service';

const getResultsWithDeadlineWarning = (results) => {
  return results.map((r) => {
    const hasDeadlineWarning = ticketService.bussiness.hasDeadlineWarning(r);
    return {
      ...r,
      hasDeadlineWarning,
    };
  });
};

const getTickets = async (...args) => {
  const endpoint = args[0].replace('tickets/', '');
  const data = await api.get(`price-negotiation/tickets/${endpoint}`);
  const resultsWithDeadlineWarningStatus = getResultsWithDeadlineWarning([
    ...data.data.results,
  ]);
  return resultsWithDeadlineWarningStatus;
};

export default getTickets;
